<template>
  <div class="main-shifts-feature-container">
    <div class="shifts-top-viki-and-charts-container">
      <ShiftsTopLeftContainer :fetch-new="fetchNew" @fetched="setFetched" :filter-dates="datesToFilter"></ShiftsTopLeftContainer>
      <notifications></notifications>
      <ShiftsTopRightContainer :filter-dates="datesToFilter"></ShiftsTopRightContainer>
    </div>
    <div class="middle-section-shifts-table">
      <shifts-main-table
          :filter-dates="datesToFilter"
          :top-left-fetched="topLeftFetched"
          style="margin-bottom: 1rem"
          @fetchNewShiftsData="getNewShiftsData"
      ></shifts-main-table>
      <shifts-calendar
         @shifts_date="filterShiftsByWeek"
        :query-object="{}"
        :selected-main-tab="'shifts'"
      ></shifts-calendar>
    </div>
    <div class="bottom-section-shifts">
      <left-bottom-chart></left-bottom-chart>
      <div class="tempLikeViki">
        <general-live-stats-sub-chart />
      </div>
      <security-cams></security-cams>
      <right-bottom-chart></right-bottom-chart>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ShiftsTopLeftContainer from "../components/ShiftsTopLeftContainer";
import ShiftsTopRightContainer from "../components/ShiftsTopRightContainer";
import GeneralLiveStatsSubChart from "../../company.feature/sub_features.company/graph.sub-feature.company/components/GeneralLiveStatsSubChart.component";
import SecurityCams from "../../security.feature/containers/SecurityCams.container";
import Notifications from "../../msg_center.feature/containers/Notifications.component";
import LeftBottomChart from "../../company.feature/sub_features.company/graph.sub-feature.company/containers/LeftBottomChart.container";
import RightBottomChart from "../../company.feature/sub_features.company/graph.sub-feature.company/containers/RightBottomChart.container";
import ShiftsCalendar from "../../shifts.feature/components/calendar/ShiftsCalendar";
import ShiftsMainTable from "@/features/shifts.feature/containers/ShiftsMainTable";

export default {
  name: "Shifts.container",
  components: {
    ShiftsMainTable,
    LeftBottomChart,
    GeneralLiveStatsSubChart,
    SecurityCams,
    Notifications,
    RightBottomChart,
    ShiftsTopRightContainer,
    ShiftsTopLeftContainer,
    ShiftsCalendar
  },
  computed: {
    ...mapState("clients", [
      "mainTabsList",
      "dictionaries",
      "enlargeCompanyTable",
      "chartsViewBlocks"
    ]),
    ...mapActions("clients", ["getActivityDictionary", "getGeneralDictionary"])
  },
  data() {
    return {
      fetchNew: false,
      topLeftFetched: false,
      datesToFilter: {}
    };
  },
  methods: {
    filterShiftsByWeek(data){
     this.datesToFilter = data
    },
    getNewShiftsData(data) {
      this.fetchNew = data;
    },
    setFetched(){
      this.topLeftFetched = !this.topLeftFetched
    }
  }
};
</script>

<style scoped>
.shifts-top-viki-and-charts-container {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}

.bottom-section-shifts {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}

.tempLikeViki {
  min-width: calc(10%);
  max-width: calc(10%);
  max-height: 100%;
}
</style>
